module.exports = __webpack_public_path__ + "img/qarabag-fk-logo-icon.df3a0101.png";